export const EMPLOYEECONTRACTTYPE_LOADING = "EMPLOYEECONTRACTTYPE_LOADING";
export const EMPLOYEECONTRACTTYPE_RESET = "EMPLOYEECONTRACTTYPE_RESET";
export const GET_EMPLOYEECONTRACTTYPE = "GET_EMPLOYEECONTRACTTYPE";
export const GET_EMPLOYEECONTRACTTYPE_SUCCESS = "GET_EMPLOYEECONTRACTTYPE_SUCCESS";
export const GET_EMPLOYEECONTRACTTYPE_FAIL = "GET_EMPLOYEECONTRACTTYPE_FAIL";
export const DELETE_EMPLOYEECONTRACTTYPE = "DELETE_EMPLOYEECONTRACTTYPE"
export const DELETE_EMPLOYEECONTRACTTYPE_SUCCESS = "DELETE_EMPLOYEECONTRACTTYPE_SUCCESS"
export const DELETE_EMPLOYEECONTRACTTYPE_FAIL = "DELETE_EMPLOYEECONTRACTTYPE_FAIL"
export const UPDATE_EMPLOYEECONTRACTTYPE = "UPDATE_EMPLOYEECONTRACTTYPE"
export const UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS = "UPDATE_EMPLOYEECONTRACTTYPE_SUCCESS"
export const UPDATE_EMPLOYEECONTRACTTYPE_FAIL = "UPDATE_EMPLOYEECONTRACTTYPE_FAIL"
export const ADD_NEW_EMPLOYEECONTRACTTYPE = "ADD_NEW_EMPLOYEECONTRACTTYPE"
export const ADD_EMPLOYEECONTRACTTYPE_SUCCESS = "ADD_EMPLOYEECONTRACTTYPE_SUCCESS"
export const ADD_EMPLOYEECONTRACTTYPE_FAIL = "ADD_EMPLOYEECONTRACTTYPE_FAIL"